import template from './partnerAssign.template.html';

export default {
  bindings: {
    onFinished: '&'
  },
  controller: class controller {
    constructor($filter, $rootScope, $mdDialog, $mdMedia, eventService) {
      'ngInject';
      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      const ctrl = this;
      ctrl.$mdDialog = $mdDialog;
      ctrl.$mdMedia = $mdMedia;
      ctrl.destroyWatch = null;

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      this.initialize = () => {
        ctrl.destroyWatch = eventService.onPartnerAssign((_params) => {
          function dialogController(currentPartner, currentAccount, partners, accounts) {
            const self = this;
            this.currentPartner = currentPartner;
            this.currentAccount = currentAccount;
            this.partners = partners;
            this.accounts = accounts;

            this.chips = accounts.map((account) => ({
              id: account.id,
              name: account.getName(),
              email: account.user.eMail,
              image: account.user.avatar
            }));

            this.chipsAssigned = $filter('filter')(this.chips, (c) => {
              if (
                self.currentPartner &&
                $rootScope.CurrentOrganization.partnersAttributes &&
                $rootScope.CurrentOrganization.partnersAttributes[currentPartner.id] &&
                $rootScope.CurrentOrganization.partnersAttributes[currentPartner.id].idOwners &&
                $rootScope.CurrentOrganization.partnersAttributes[currentPartner.id].idOwners
                  .length
              ) {
                return _.find(
                  $rootScope.CurrentOrganization.partnersAttributes[currentPartner.id].idOwners,
                  (o) => o === c.id
                );
              }
              if (self.currentAccount && $rootScope.CurrentOrganization.partnersAttributes) {
                return _.find(
                  $rootScope.CurrentOrganization.partnersAttributes,
                  (o) => o.idOwners.indexOf(c.id) > -1
                );
              }
              return null;
            });
            this.chipsFilter = (query) =>
              query
                ? $filter('filter')(
                    this.chips,
                    (c) => c.name.toLowerCase().indexOf(query.toLowerCase()) > -1
                  )
                : [];
            this.confirm = () => {
              const accs = $filter('filter')(this.accounts, (a) =>
                _.find(self.chipsAssigned, (c) => c.id === a.id)
              );
              $mdDialog.hide({
                currentPartner: self.currentPartner,
                currentAccount: self.currentAccount,
                accounts: accs
              });
            };
            this.cancel = () => {
              $mdDialog.cancel();
            };
          }

          $mdDialog
            .show({
              targetEvent: _params.event,
              locals: {
                currentPartner: _params.currentPartner,
                currentAccount: _params.currentAccount,
                partners: _params.partners,
                accounts: _params.accounts
              },
              template,
              controllerAs: '$ctrl',
              controller: dialogController
            })
            .then((r) => {
              ctrl.onFinished({
                currentPartner: r.currentPartner,
                currentAccount: r.currentAccount,
                accounts: r.accounts
              });
            });
        });
      };

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      this.$onInit = () => {
        ctrl.initialize();
      };

      /*
       * Execute when bindings change
       * --------------------------------------------------------------------------------
       */
      this.$onChanges = () => {};

      /*
       * Execute when component is not necessary anymore
       * --------------------------------------------------------------------------------
       */
      this.$onDestroy = () => {
        ctrl.destroyWatch();
      };
    }
  }
};
